import { useSelector } from 'react-redux';
import { formatRupiah } from '../../../../utils/helper';
import { TagIcon } from '../../../../utils/svg';

const Voucher = () => {
	const { details: outlet } = useSelector((store) => store?.outlet);

	return (
		<>
			<div className='overflow-x-auto scrollbar-hide pb-3 mx-4'>
				<div className='flex flex-row flex-nowrap gap-2'>
					{outlet?.voucher_global?.map((vg, index) => {
						const type = vg?.type === 'percentage';
						const diskon = vg?.type === 'percentage' ? `${vg?.value}%` : formatRupiah(vg?.value);
						const maxDiskon = formatRupiah(vg?.max_discount || 0);
						const title = vg?.purpose === 'PRODUCT' ? (type ? `Diskon Menu ${diskon} up to ${maxDiskon}` : `Diskon Menu ${diskon}`) : type ? `Free Ongkir ${diskon} up to ${maxDiskon}` : `Free Ongkir ${diskon}`;
						const desc = vg?.min_transaction > 0 ? `Min Spend ${formatRupiah(vg?.min_transaction || 0)}` : 'Tanpa Min Spend';
						return (
							<div key={index} className='flex items-center gap-1 font-medium text-xxs text-green-700 bg-green-100 flex-shrink-0 py-1 px-1.5 rounded-md'>
								<TagIcon className='h-3 w-auto fill-green-600' />
								{title}
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default Voucher;
